const ENV = {
  acp: {
    baseUrl: "https://acp-isni-formulaires.banq.qc.ca/"
  },
  dev: {
    baseUrl: "https://dev-isni-formulaires.banq.qc.ca/"
  },
  dev1: {
    baseUrl: "https://dev1-isni-formulaires.banq.qc.ca/"
  },
  prod: {
    baseUrl: "https://isni-formulaires.banq.qc.ca/"
  }
};
const TYPE_FORM = {
  perso: "personne",
  orga: "organisme"
};
export const Constants = {
  ENV: ENV,
  TYPE_FORM: TYPE_FORM
};
